var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-app",
    [
      _c(
        "v-app-bar",
        {
          staticClass: "white elevation-2",
          attrs: { "clipped-left": "", fixed: "", app: "" }
        },
        [
          _c("v-app-bar-nav-icon", {
            on: {
              click: function($event) {
                _vm.drawer = !_vm.drawer
              }
            }
          }),
          _vm._v(" "),
          _c(
            "v-btn",
            {
              staticClass: "ml-2",
              attrs: { icon: "" },
              on: {
                click: function($event) {
                  return _vm.reload()
                }
              }
            },
            [
              _c("v-icon", {
                staticClass: "blue--text",
                attrs: { "x-large": "" },
                domProps: { textContent: _vm._s("mdi-cached") }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("v-toolbar-title", {
            staticClass: "black--text p1-1",
            domProps: { textContent: _vm._s(_vm.title) }
          }),
          _vm._v(" "),
          _c("v-spacer"),
          _vm._v(" "),
          _c("v-toolbar-title", {
            staticClass: "font-weight-black",
            domProps: { textContent: _vm._s(_vm.$store.state.childPageTitle) }
          }),
          _vm._v(" "),
          _c("v-spacer"),
          _vm._v(" "),
          _c("AccountMenu")
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-navigation-drawer",
        {
          staticClass: "elevation-20 primary",
          attrs: { clipped: "", app: "" },
          model: {
            value: _vm.drawer,
            callback: function($$v) {
              _vm.drawer = $$v
            },
            expression: "drawer"
          }
        },
        [
          _c(
            "v-list",
            { attrs: { dense: "", nav: "", dark: "" } },
            _vm._l(_vm.items, function(item, i) {
              return _c(
                "v-list-item",
                {
                  key: i,
                  staticClass: "pa-2 ma-2",
                  attrs: { to: item.to, router: "", exact: "", color: "white" },
                  on: {
                    click: function($event) {
                      _vm.drawer = !_vm.drawer
                    }
                  }
                },
                [
                  _c(
                    "v-list-item-action",
                    [
                      _c("v-icon", {
                        attrs: { large: "" },
                        domProps: { textContent: _vm._s(item.icon) }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-list-item-content",
                    [
                      _c("v-list-item-title", {
                        staticClass: "subtitle-1",
                        domProps: { textContent: _vm._s(item.title) }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            }),
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-main",
        { staticClass: "min-width=90vw" },
        [
          _c(
            "v-container",
            { staticClass: "mb-15 d-flex justify-center" },
            [_c("nuxt")],
            1
          ),
          _vm._v(" "),
          _c(
            "v-container",
            { staticClass: "d-flex justify-center" },
            [_c("FooterLogo")],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }